<button
  class="cart-side-panel-toggle"
  ftrButton
  color="white"
  size="extra-small"
  ftrDrawer
  [drawerContent]="cartTemplate"
  drawerPosition="right"
  [drawerEnableAriaHints]="false"
  [attr.aria-label]="cartButtonAriaLabel()"
>
  <ftr-icon icon="Cart" color="Grey40" align="Middle" />
  @if (hasCartItems()) {
    <span class="cart-side-panel-toggle__count-container">
      <span class="cart-side-panel-toggle__count">{{ numCartItems() }}</span>
    </span>
  }
</button>
<ng-template #cartTemplate let-drawerContext>
  <ftr-request-cart-side-panel
    [courtSystemId]="courtSystemId()"
    [requestType]="requestType()"
    (closePanel)="drawerContext.close()"
  />
</ng-template>
